export const mdFields = {


    /** 
     * Nouvelles organisation du fichier de configuration
     * 
     * Principe:
     *  - xpaths correspond à la liste des chemin xpaths pour rechercher ou alimenter la valeur principale du champ
     *  - xpaths est composé de 2 propriétés:
     *      - value: la liste des xpaths de la valeur spécifique au champ concerné (chemin de base dans l'objet du champ)
     *      - root: la racine qu'il faut ajouter au chemin de base pour atteindre la valeur dans l'objet global (mdjs)
     *  - attributes correspond à la liste des autre valeurs prédéfinies (attribut). Chaque attribut est constitué d'un tableau. L'indice 0 est le chemin de base de l'attribut dans l'objet et l'indice la valeur par défaut de cet attribut.
     * 
     * Besoin d'adapter les fonction get() et set() de xmlConverter
     * A TESTER ET VALIDER
     */

    mdFileIdentifier: {
        xpaths: {
            value: ['gmd:MD_Metadata[0].gmd:fileIdentifier[0].gco:CharacterString[0]._text[0]']
        }
    },
    mdParentIdentifier: {
        xpaths: {
            value: ['gmd:MD_Metadata[0].gmd:parentIdentifier[0].gco:CharacterString[0]._text[0]']
        }
    },
    mdLanguage: {
        xpaths: {
            value: [ // liste des xpaths pour value
                'gmd:MD_Metadata[0].gmd:language[0].gmd:LanguageCode[0]._text[0]',
                'gmd:MD_Metadata[0].gmd:language[0].gmd:LanguageCode[0]._attributes.codeListValue',
            ]
        },
        attributes: {
            codelist: [
                'gmd:MD_Metadata[0].gmd:language[0].gmd:LanguageCode[0]._attributes.codeList',
                'http://www.loc.gov/standards/iso639-2/'
            ]
        }
    },
    mdCharacterSet: {
        xpaths: {
            value: [
                'gmd:MD_Metadata[0].gmd:characterSet[0].gmd:MD_CharacterSetCode[0]._text[0]',
                'gmd:MD_Metadata[0].gmd:characterSet[0].gmd:MD_CharacterSetCode[0]._attributes.codeListValue'
            ]
        },
        attributes: {
            codelist: [
                'gmd:MD_Metadata[0].gmd:characterSet[0].gmd:MD_CharacterSetCode[0]._attributes.codeList',
                'http://www.isotc211.org/2005/resources/codeList.xml#MD_CharacterSetCode'
            ]
        }
    },
    mdHierarchyLevel: {
        xpaths: {
            value: [
                'gmd:MD_Metadata[0].gmd:hierarchyLevel[0].gmd:MD_ScopeCode[0]._text[0]',
                'gmd:MD_Metadata[0].gmd:hierarchyLevel[0].gmd:MD_ScopeCode[0]._attributes.codeListValue'
            ]
        },
        attributes: {
            codelist: ['gmd:MD_Metadata[0].gmd:hierarchyLevel[0].gmd:MD_ScopeCode[0]._attributes.codeList',
                'http://standards.iso.org/ittf/PubliclyAvailableStandards/ISO_19139_Schemas/resources/Codelist/ML_gmxCodelists.xml#MD_ScopeCode'
            ]
        }
    },

    //...

    // dataLanguages: {
    //     xpaths: {
    //         root: [
    //             'gmd:MD_Metadata[0].gmd:identificationInfo[0].gmd:MD_DataIdentification[0].gmd:language[*]'
    //         ],
    //         value: [
    //             'gmd:LanguageCode[0]._text[0]',
    //             'gmd:LanguageCode[0]._attributes.codeListValue'
    //         ]
    //     },
    //     attributes: {
    //         codelist: [
    //             'gmd:LanguageCode[0]._attributes.codeList',
    //             'http://www.loc.gov/standards/iso639-2/'
    //         ]
    //     }
    // },

    // Fin de test



    // mdFileIdentifier: {
    //     xpaths: {
    //         value: 'gmd:MD_Metadata[0].gmd:fileIdentifier[0].gco:CharacterString[0]._text[0]'
    //     }
    // },
    mdParentIdentifier: {
        xpaths: {
            value: ['gmd:MD_Metadata[0].gmd:parentIdentifier[0].gco:CharacterString[0]._text[0]']
        }
    },
    mdLanguage: {
        xpaths: {
            value: [
                'gmd:MD_Metadata[0].gmd:language[0].gmd:LanguageCode[0]._text[0]',
                'gmd:MD_Metadata[0].gmd:language[0].gmd:LanguageCode[0]._attributes.codeListValue'
            ]
        },
        attributes: {
            codelist: [
                'gmd:MD_Metadata[0].gmd:language[0].gmd:LanguageCode[0]._attributes.codeList',
                'http://www.loc.gov/standards/iso639-2/'
            ]
        }
    },
    mdCharacterSet: {
        xpaths: {
            value: [
                'gmd:MD_Metadata[0].gmd:characterSet[0].gmd:MD_CharacterSetCode[0]._text[0]',
                'gmd:MD_Metadata[0].gmd:characterSet[0].gmd:MD_CharacterSetCode[0]._attributes.codeListValue'
            ]
        },
        attributes: {
            codelist: [
                'gmd:MD_Metadata[0].gmd:characterSet[0].gmd:MD_CharacterSetCode[0]._attributes.codeList',
                'http://www.isotc211.org/2005/resources/codeList.xml#MD_CharacterSetCode'
            ]
        }
    },
    mdHierarchyLevel: {
        xpaths: {
            value: [
                'gmd:MD_Metadata[0].gmd:hierarchyLevel[0].gmd:MD_ScopeCode[0]._text[0]',
                'gmd:MD_Metadata[0].gmd:hierarchyLevel[0].gmd:MD_ScopeCode[0]._attributes.codeListValue'
            ]
        },
        attributes: {
            codelist: [
                'gmd:MD_Metadata[0].gmd:hierarchyLevel[0].gmd:MD_ScopeCode[0]._attributes.codeList',
                'http://standards.iso.org/ittf/PubliclyAvailableStandards/ISO_19139_Schemas/resources/Codelist/ML_gmxCodelists.xml#MD_ScopeCode'
            ]
        }
    },


    mdContacts: {
        xpaths: {
            value: ['gmd:MD_Metadata[0].gmd:contact[*]']
        }
    },

    // CONTACT - start
    individualName: {
        xpaths: {
            value: ['gmd:CI_ResponsibleParty[0].gmd:individualName[0].gco:CharacterString[0]._text[0]']
        }
    },
    positionName: {
        xpaths: {
            value: ['gmd:CI_ResponsibleParty[0].gmd:positionName[0].gco:CharacterString[0]._text[0]']
        }
    },
    organisationName: {
        xpaths: {
            value: ['gmd:CI_ResponsibleParty[0].gmd:organisationName[0].gco:CharacterString[0]._text[0]']
        }
    },
    phoneVoices: {
        xpaths: {
            root: ['gmd:CI_ResponsibleParty[0].gmd:contactInfo[0].gmd:CI_Contact[0].gmd:phone[0].gmd:CI_Telephone[0].gmd:voice[*]'],
            value: ['gco:CharacterString[0]._text[0]']
        }
    },
    emails: {
        xpaths: {
            root: ['gmd:CI_ResponsibleParty[0].gmd:contactInfo[0].gmd:CI_Contact[0].gmd:address[0].gmd:CI_Address[0].gmd:electronicMailAddress[*]'],
            value: ['gco:CharacterString[0]._text[0]']
        }
    },
    deliveryPoints: {
        xpaths: {
            root: ['gmd:CI_ResponsibleParty[0].gmd:contactInfo[0].gmd:CI_Contact[0].gmd:address[0].gmd:CI_Address[0].gmd:deliveryPoint[*]'],
            value: ['gco:CharacterString[0]._text[0]']
        }
    },
    postalCode: {
        xpaths: {
            value: ['gmd:CI_ResponsibleParty[0].gmd:contactInfo[0].gmd:CI_Contact[0].gmd:address[0].gmd:CI_Address[0].gmd:postalCode[0].gco:CharacterString[0]._text[0]']
        }
    },
    city: {
        xpaths: {
            value: ['gmd:CI_ResponsibleParty[0].gmd:contactInfo[0].gmd:CI_Contact[0].gmd:address[0].gmd:CI_Address[0].gmd:city[0].gco:CharacterString[0]._text[0]']
        }
    },
    country: {
        xpaths: {
            value: ['gmd:CI_ResponsibleParty[0].gmd:contactInfo[0].gmd:CI_Contact[0].gmd:address[0].gmd:CI_Address[0].gmd:country[0].gco:CharacterString[0]._text[0]']
        }
    },
    logoUrl: {
        xpaths: {
            value: [
                'gmd:CI_ResponsibleParty[0].gmd:contactInfo[0].gmd:CI_Contact[0].gmd:contactInstructions[0].gmx:FileName[0]._attributes.src',
                'gmd:CI_ResponsibleParty[0].gmd:contactInfo[0].gmd:CI_Contact[0].gmd:contactInstructions[0].gmx:FileName[0]._attributes.src'
            ]
        }
    },
    logoDescription: {
        xpaths: {
            value: ['gmd:CI_ResponsibleParty[0].gmd:contactInfo[0].gmd:CI_Contact[0].gmd:contactInstructions[0].gmx:FileName[0]._text[0]']
        }
    },
    role: {
        xpaths: {
            value: [
                'gmd:CI_ResponsibleParty[0].gmd:role[0].gmd:CI_RoleCode[0]._text[0]',
                'gmd:CI_ResponsibleParty[0].gmd:role[0].gmd:CI_RoleCode[0]._attributes.codeListValue'
            ]
        },
        attributes: {
            codelist: [
                'gmd:CI_ResponsibleParty[0].gmd:role[0].gmd:CI_RoleCode[0]._attributes.codeList',
                'http://standards.iso.org/ittf/PubliclyAvailableStandards/ISO_19139_Schemas/resources/Codelist/ML_gmxCodelists.xml#CI_RoleCode'
            ]
        }
    },
    // CONTACT - end

    mdDateStamp: {
        xpaths: {
            value: ['gmd:MD_Metadata[0].gmd:dateStamp[0].gco:Date[0]._text[0]']
        }
    },
    mdDateTimeStamp: {
        xpaths: {
            value: ['gmd:MD_Metadata[0].gmd:dateStamp[0].gco:DateTime[0]._text[0]']
        }
    },
    mdStandardName: {
        xpaths: {
            value: ['gmd:MD_Metadata[0].gmd:metadataStandardName[0].gco:CharacterString[0]._text[0]']
        }
    },
    mdStandardVersion: {
        xpaths: {
            value: ['gmd:MD_Metadata[0].gmd:metadataStandardVersion[0].gco:CharacterString[0]._text[0]']
        }
    },

    __mdFileIdentifier: {
        xpaths: {
            value: ['gmd:MD_Metadata[0].gmd:fileIdentifier[0].gco:CharacterString[0]._text[0]']
        }
    },

    dataTitle: {
        xpaths: {
            value: ['gmd:MD_Metadata[0].gmd:identificationInfo[0].gmd:MD_DataIdentification[0].gmd:citation[0].gmd:CI_Citation[0].gmd:title[0].gco:CharacterString[0]._text[0]']
        }
    },
    srvTitle: {
        xpaths: {
            value: ['gmd:MD_Metadata[0].gmd:identificationInfo[0].srv:SV_ServiceIdentification[0].gmd:citation[0].gmd:CI_Citation[0].gmd:title[0].gco:CharacterString[0]._text[0]']
        }
    },
    dataDates: {
        xpaths: {
            value: ['gmd:MD_Metadata[0].gmd:identificationInfo[0].gmd:MD_DataIdentification[0].gmd:citation[0].gmd:CI_Citation[0].gmd:date[*]']
        }
    },
    dateType: {
        xpaths: {
            value: [
                'gmd:CI_Date[0].gmd:dateType[0].gmd:CI_DateTypeCode[0]._text[0]',
                'gmd:CI_Date[0].gmd:dateType[0].gmd:CI_DateTypeCode[0]._attributes.codeListValue'
            ]
        },
        attributes: {
            codelist: [
                'gmd:CI_Date[0].gmd:dateType[0].gmd:CI_DateTypeCode[0]._attributes.codeList',
                'http://standards.iso.org/ittf/PubliclyAvailableStandards/ISO_19139_Schemas/resources/Codelist/ML_gmxCodelists.xml#CI_DateTypeCode'
            ]
        }
    },
    dateTime: {
        xpaths: {
            value: ['gmd:CI_Date[0].gmd:date[0].gco:DateTime[0]._text[0]']
        }
    },
    date: {
        xpaths: {
            value: ['gmd:CI_Date[0].gmd:date[0].gco:Date[0]._text[0]']
        }
    },




    dataIdentifiers: {
        xpaths: {
            value: ['gmd:MD_Metadata[0].gmd:identificationInfo[0].gmd:MD_DataIdentification[0].gmd:citation[0].gmd:CI_Citation[0].gmd:identifier[*]']
        }
    },
    dataIdentifiersCodes: {
        description: 'only to read data',
        xpaths: {
            root: ['gmd:MD_Metadata[0].gmd:identificationInfo[0].gmd:MD_DataIdentification[0].gmd:citation[0].gmd:CI_Citation[0].gmd:identifier[*]'],
            value: ['.gmd:code[0].gco:CharacterString[0]._text[0]']
        }
    },
    _dataIdentifiersCodes: {
        description: 'only to read data',
        xpaths: {
            root: ['gmd:MD_Metadata[0].gmd:identificationInfo[0].gmd:MD_DataIdentification[0].gmd:citation[0].gmd:CI_Citation[0].gmd:identifier[*]'],
            value: ['gmd:code[0].gco:CharacterString[0]._text[0]']
        }
    },
    code: {
        xpaths: {
            value: ['gmd:RS_Identifier[0].gmd:code[0].gco:CharacterString[0]._text[0]']
        }
    },
    codeSpace: {
        xpaths: {
            value: ['gmd:RS_Identifier[0].gmd:codeSpace[0].gco:CharacterString[0]._text[0]']
        }
    },
    mdCode: {
        xpaths: {
            value: ['gmd:MD_Identifier[0].gmd:code[0].gco:CharacterString[0]._text[0]']
        }
    },
    dataAbstract: {
        xpaths: {
            value: ['gmd:MD_Metadata[0].gmd:identificationInfo[0].gmd:MD_DataIdentification[0].gmd:abstract[0].gco:CharacterString[0]._text[0]']
        }
    },
    srvAbstract: {
        xpaths: {
            value: ['gmd:MD_Metadata[0].gmd:identificationInfo[0].srv:SV_ServiceIdentification[0].gmd:abstract[0].gco:CharacterString[0]._text[0]']
        }
    },
    dataBrowseGraphics: {
        xpaths: {
            value: ['gmd:MD_Metadata[0].gmd:identificationInfo[0].gmd:MD_DataIdentification[0].gmd:graphicOverview[*]']
        }
    },
    srvBrowseGraphics: {
        xpaths: {
            value: ['gmd:MD_Metadata[0].gmd:identificationInfo[0].srv:SV_ServiceIdentification[0].gmd:graphicOverview[*]']
        }
    },
    fileName: {
        xpaths: {
            value: ['gmd:MD_BrowseGraphic[0].gmd:fileName[0].gco:CharacterString[0]._text[0]']
        }
    },
    fileDescription: {
        xpaths: {
            value: ['gmd:MD_BrowseGraphic[0].gmd:fileDescription[0].gco:CharacterString[0]._text[0]']
        }
    },
    fileType: {
        xpaths: {
            value: ['gmd:MD_BrowseGraphic[0].gmd:fileType[0].gco:CharacterString[0]._text[0]']
        }
    },
    dataMaintenanceFrequency: {
        xpaths: {
            value: [
                'gmd:MD_Metadata[0].gmd:identificationInfo[0].gmd:MD_DataIdentification[0].gmd:resourceMaintenance[0].gmd:MD_MaintenanceInformation[0].gmd:maintenanceAndUpdateFrequency[0].gmd:MD_MaintenanceFrequencyCode[0]._text[0]',
                'gmd:MD_Metadata[0].gmd:identificationInfo[0].gmd:MD_DataIdentification[0].gmd:resourceMaintenance[0].gmd:MD_MaintenanceInformation[0].gmd:maintenanceAndUpdateFrequency[0].gmd:MD_MaintenanceFrequencyCode[0]._attributes.codeListValue'
            ],
        },
        attributes: {
            codelist: [
                'gmd:MD_Metadata[0].gmd:identificationInfo[0].gmd:MD_DataIdentification[0].gmd:resourceMaintenance[0].gmd:MD_MaintenanceInformation[0].gmd:maintenanceAndUpdateFrequency[0].gmd:MD_MaintenanceFrequencyCode[0]._attributes.codeList',
                'http://standards.iso.org/ittf/PubliclyAvailableStandards/ISO_19139_Schemas/resources/Codelist/ML_gmxCodelists.xml#MD_MaintenanceFrequencyCode'
            ]
        }
    },
    // dataLanguages: {
    //     xpaths: {
    //         root: ['gmd:MD_Metadata[0].gmd:identificationInfo[0].gmd:MD_DataIdentification[0].gmd:language[*]'],
    //         value: 'gmd:LanguageCode[0]._text[0]',
    //         code: 'gmd:LanguageCode[0]._attributes.codeListValue',
    //         codelist: 'gmd:LanguageCode[0]._attributes.codeList',
    //     },
    //     attributes: {
    //         codelist: 'http://www.loc.gov/standards/iso639-2/'
    //     }
    // },
    dataLanguages: {
        xpaths: {
            root: [
                'gmd:MD_Metadata[0].gmd:identificationInfo[0].gmd:MD_DataIdentification[0].gmd:language[*]'
            ],
            value: [
                'gmd:LanguageCode[0]._text[0]',
                'gmd:LanguageCode[0]._attributes.codeListValue'
            ]
        },
        attributes: {
            codelist: [
                'gmd:LanguageCode[0]._attributes.codeList',
                'http://www.loc.gov/standards/iso639-2/'
            ]
        }
    },
    dataTopicCategories: {
        xpaths: {
            // root: ['gmd:MD_Metadata[0].gmd:identificationInfo[0].gmd:MD_DataIdentification[0].gmd:topicCategory[*]'],
            root: ['gmd:MD_Metadata[0].gmd:identificationInfo[0].gmd:MD_DataIdentification[0].gmd:topicCategory[*]'],
            value: ['gmd:MD_TopicCategoryCode[0]._text[0]']
        }
    },
    srvTopicCategories: {
        xpaths: {
            root: ['gmd:MD_Metadata[0].gmd:identificationInfo[0].srv:SV_ServiceIdentification[0].gmd:topicCategory[*]'],
            value: ['gmd:MD_TopicCategoryCode[0]._text[0]']
        }
    },
    dataKeywordsList: {
        description: 'only to read data',
        xpaths: {
            root: [
                'gmd:MD_Metadata[0].gmd:identificationInfo[0].gmd:MD_DataIdentification[0].gmd:descriptiveKeywords[*]',
                'gmd:MD_Keywords[0].gmd:keyword[*]'
            ],
            value: ['gco:CharacterString[0]._text[0]']
        }
    },
    dataKeywords: {
        xpaths: {
            value: ['gmd:MD_Metadata[0].gmd:identificationInfo[0].gmd:MD_DataIdentification[0].gmd:descriptiveKeywords[*]']
        }
    },
    srvKeywords: {
        xpaths: {
            value: ['gmd:MD_Metadata[0].gmd:identificationInfo[0].srv:SV_ServiceIdentification[0].gmd:descriptiveKeywords[*]']
        }
    },
    keyword: {
        xpaths: {
            root: ['gmd:MD_Keywords[0].gmd:keyword[*]'],
            value: ['gco:CharacterString[0]._text[0]']
        }
    },
    keywordType: {
        xpaths: {
            value: [
                'gmd:MD_Keywords[0].gmd:type[0].gmd:MD_KeywordTypeCode[0]._text[0]',
                'gmd:MD_Keywords[0].gmd:type[0].gmd:MD_KeywordTypeCode[0]._attributes.codeListValue'
            ]
        },
        attributes: {
            codelist: [
                'gmd:MD_Keywords[0].gmd:type[0].gmd:MD_KeywordTypeCode[0]._attributes.codeList',
                'http://www.isotc211.org/2005/resources/codeList.xml#MD_KeywordTypeCode'
            ]
        }
    },
    thesaurusName: {
        xpaths: {
            value: ['gmd:MD_Keywords[0].gmd:thesaurusName[0].gmd:CI_Citation[0].gmd:title[0].gco:CharacterString[0]._text[0]']
        }
    },
    thesaurusDatePublication: {
        xpaths: {
            root: [
                'gmd:MD_Keywords[0].gmd:thesaurusName[0].gmd:CI_Citation[0].gmd:date[*]'
            ],
            value: ['gmd:CI_Date[0].gmd:date[0].gco:Date[0]._text[0]']
        }
    },
    thesaurusDates: {
        xpaths: {
            value: ['gmd:MD_Keywords[0].gmd:thesaurusName[0].gmd:CI_Citation[0].gmd:date']
        }
    },
    thesaurusDates: {
        xpaths: {
            value: ['gmd:MD_Keywords[0].gmd:thesaurusName[0].gmd:CI_Citation[0].gmd:date']
        }
    },
    dataInspireKeywords: {
        xpaths: {
            value: ['gmd:MD_Metadata[0].gmd:identificationInfo[0].gmd:MD_DataIdentification[0].gmd:descriptiveKeywords[*]']
        }
    },
    _dataInspireKeywordsList: {
        description: 'Only to read data',
        xpaths: {
            root: [
                'gmd:MD_Metadata[0].gmd:identificationInfo[0].gmd:MD_DataIdentification[0].gmd:descriptiveKeywords[*]',
                'gmd:MD_Keywords[0].gmd:keyword[*]'
            ],
            value: ['gco:CharacterString[0]._text[0]']
        }
    },
    dataInspireKeywordsList: {
        description: 'Only to read data',
        xpaths: {
            root: [
                'gmd:MD_Keywords[0].gmd:keyword[*]'
            ],
            value: ['gco:CharacterString[0]._text[0]']
        }
    },

    dataThemeKeywords: {
        xpaths: {
            value: ['gmd:MD_Metadata[0].gmd:identificationInfo[0].gmd:MD_DataIdentification[0].gmd:descriptiveKeywords[*]']
        }
    },
    dataThemeKeywordsList: {
        description: 'Only to read data',
        xpaths: {
            root: [
                'gmd:MD_Metadata[0].gmd:identificationInfo[0].gmd:MD_DataIdentification[0].gmd:descriptiveKeywords[*]',
                'gmd:MD_Keywords[0].gmd:keyword[*]'
            ],
            value: ['gco:CharacterString[0]._text[0]']
        }
    },

    dataPointOfContacts: {
        xpaths: {
            value: ['gmd:MD_Metadata[0].gmd:identificationInfo[0].gmd:MD_DataIdentification[0].gmd:pointOfContact[*]']
        }
    },

    dataExtents: {
        xpaths: {
            value: ['gmd:MD_Metadata[0].gmd:identificationInfo[0].gmd:MD_DataIdentification[0].gmd:extent[*]']
        }
    },
    srvExtents: {
        xpaths: {
            value: ['gmd:MD_Metadata[0].gmd:identificationInfo[0].srv:SV_ServiceIdentification[0].gmd:extent[*]']
        }
    },
    extentName: {
        xpaths: {
            value: ['gmd:EX_Extent[0].gmd:description[0].gco:CharacterString[0]._text[0]']
        }
    },
    geographicExtent: {
        xpaths: {
            value: ['gmd:EX_Extent[0].gmd:geographicElement[*]']
        }
    },
    geographicExtentWestBound: {
        xpaths: {
            value: ['gmd:EX_Extent[0].gmd:geographicElement[0].gmd:EX_GeographicBoundingBox[0].gmd:westBoundLongitude[0].gco:Decimal[0]._text[0]']
        }
    },
    geographicExtentEastBound: {
        xpaths: {
            value: ['gmd:EX_Extent[0].gmd:geographicElement[0].gmd:EX_GeographicBoundingBox[0].gmd:eastBoundLongitude[0].gco:Decimal[0]._text[0]']
        }
    },
    geographicExtentSouthBound: {
        xpaths: {
            value: ['gmd:EX_Extent[0].gmd:geographicElement[0].gmd:EX_GeographicBoundingBox[0].gmd:southBoundLatitude[0].gco:Decimal[0]._text[0]']
        }
    },
    geographicExtentNorthBound: {
        xpaths: {
            value: ['gmd:EX_Extent[0].gmd:geographicElement[0].gmd:EX_GeographicBoundingBox[0].gmd:northBoundLatitude[0].gco:Decimal[0]._text[0]']
        }
    },

    temporalExtent: {
        xpaths: {
            value: ['gmd:EX_Extent[0].gmd:temporalElement[*]']
        },
    },
    temporalExtentBegin: {
        xpaths: {
            value: ['gmd:EX_Extent[0].gmd:temporalElement[0].gmd:EX_TemporalExtent[0].gmd:extent[0].gml:TimePeriod[0].gml:beginPosition[0]._text[0]']
        }
    },
    temporalExtentEnd: {
        xpaths: {
            value: ['gmd:EX_Extent[0].gmd:temporalElement[0].gmd:EX_TemporalExtent[0].gmd:extent[0].gml:TimePeriod[0].gml:endPosition[0]._text[0]']
        }
    },

    dataReferenceSystems: {
        xpaths: {
            value: ['gmd:MD_Metadata[0].gmd:referenceSystemInfo[*]']
        }
    },
    referenceSystemCode: {
        xpaths: {
            value: ['gmd:MD_ReferenceSystem[0].gmd:referenceSystemIdentifier[0].gmd:RS_Identifier[0].gmd:code[0].gco:CharacterString[0]._text[0]']
        }
    },
    referenceSystemCodeSpace: {
        xpaths: {
            value: ['gmd:MD_ReferenceSystem[0].gmd:referenceSystemIdentifier[0].gmd:RS_Identifier[0].gmd:codeSpace[0].gco:CharacterString[0]._text[0]']
        }
    },
    dataPresentationForm: {
        xpaths: {
            value: ['']
        }
    },

    dataSpatialRepresentationType: {
        xpaths: {
            value: [
                'gmd:MD_Metadata[0].gmd:identificationInfo[0].gmd:MD_DataIdentification[0].gmd:spatialRepresentationType[0].gmd:MD_SpatialRepresentationTypeCode[0]._text[0]',
                'gmd:MD_Metadata[0].gmd:identificationInfo[0].gmd:MD_DataIdentification[0].gmd:spatialRepresentationType[0].gmd:MD_SpatialRepresentationTypeCode[0]._attributes.codeListValue'
            ]
        },
        attributes: {
            codelist: [
                'gmd:MD_Metadata[0].gmd:identificationInfo[0].gmd:MD_DataIdentification[0].gmd:spatialRepresentationType[0].gmd:MD_SpatialRepresentationTypeCode[0]._attributes.codeList',
                'http://www.isotc211.org/2005/resources/codeList.xml#MD_SpatialRepresentationTypeCode'
            ]
        }
    },
    dataScaleDenominator: {
        xpaths: {
            value: ['gmd:MD_Metadata[0].gmd:identificationInfo[0].gmd:MD_DataIdentification[0].gmd:spatialResolution[0].gmd:MD_Resolution[0].gmd:equivalentScale[0].gmd:MD_RepresentativeFraction[0].gmd:denominator[0].gco:Integer[0]._text[0]']
        }
    },
    dataScaleDistance: {
        xpaths: {
            value: ['gmd:MD_Metadata[0].gmd:identificationInfo[0].gmd:MD_DataIdentification[0].gmd:spatialResolution[0].gmd:MD_Resolution[0].gmd:distance[0].gco:Distance[0]._text[0]']
        }
    },
    dataLiStatement: {
        xpaths: {
            value: ['gmd:MD_Metadata[0].gmd:dataQualityInfo[0].gmd:DQ_DataQuality[0].gmd:lineage[0].gmd:LI_Lineage[0].gmd:statement[0].gco:CharacterString[0]._text[0]']
        }
    },
    dataCharacterSet: {
        xpaths: {
            value: [
                'gmd:MD_Metadata[0].gmd:identificationInfo[0].gmd:MD_DataIdentification[0].gmd:characterSet[0].gmd:MD_CharacterSetCode[0]._text[0]',
                'gmd:MD_Metadata[0].gmd:identificationInfo[0].gmd:MD_DataIdentification[0].gmd:characterSet[0].gmd:MD_CharacterSetCode[0]._attributes.codeListValue'
            ]
        },
        attributes: {
            codelist: [
                'gmd:MD_Metadata[0].gmd:identificationInfo[0].gmd:MD_DataIdentification[0].gmd:characterSet[0].gmd:MD_CharacterSetCode[0]._attributes.codeList',
                'http://www.isotc211.org/2005/resources/codeList.xml#MD_CharacterSetCode'
            ]
        }
    },
    dataDistributionFormats: {
        xpaths: {
            value: ['gmd:MD_Metadata[0].gmd:distributionInfo[0].gmd:MD_Distribution[0].gmd:distributionFormat[*]']
        }
    },
    formatName: {
        xpaths: {
            value: ['gmd:MD_Format[0].gmd:name[0].gco:CharacterString[0]._text[0]']
        }
    },
    formatVersion: {
        xpaths: {
            value: ['gmd:MD_Format[0].gmd:version[0].gco:CharacterString[0]._text[0]']
        }
    },
    formatSpecification: {
        xpaths: {
            value: ['gmd:MD_Format[0].gmd:specification[0].gco:CharacterString[0]._text[0]']
        }
    },
    dataResourceConstraints: {
        xpaths: {
            value: ['gmd:MD_Metadata[0].gmd:identificationInfo[0].gmd:MD_DataIdentification[0].gmd:resourceConstraints[*]']
        }
    },
    srvResourceConstraints: {
        xpaths: {
            value: ['gmd:MD_Metadata[0].gmd:identificationInfo[0].srv:SV_ServiceIdentification[0].gmd:resourceConstraints[*]']
        }
    },
    dataUseLimitations: {
        xpaths: {
            root: [
                // 'gmd:MD_Metadata[0].gmd:identificationInfo[0].gmd:MD_DataIdentification[0].gmd:resourceConstraints[*]',
                'gmd:MD_Constraints[0].gmd:useLimitation[*]'
            ],
            value: [
                'gco:CharacterString[0]._text'
            ]
        }
    },
    srvUseLimitations: {
        xpaths: {
            root: ['gmd:MD_Constraints[0].gmd:useLimitation[*]'],
            value: ['gco:CharacterString[0]._text[0]']
        }
    },
    dataLegalConstraints: {
        xpaths: {
            value: ['gmd:MD_LegalConstraints[*]']
        }
    },
    dataLegalUseLimitations: {
        xpaths: {
            root: ['gmd:MD_LegalConstraints[0].gmd:useLimitation[*]'],
            value: ['gco:CharacterString[0]._text[0]']
        }
    },
    dataLegalUseConstraints: {
        xpaths: {
            root: ['gmd:MD_LegalConstraints[0].gmd:useConstraints[*]'],
            value: [
                'gmd:MD_RestrictionCode[0]._text[0]',
                'gmd:MD_RestrictionCode[0]._attributes.codeListValue']
        },
        attributes: {
            codelist: [
                'gmd:MD_RestrictionCode[0]._attributes.codeList',
                'http://standards.iso.org/ittf/PubliclyAvailableStandards/ISO_19139_Schemas/resources/Codelist/ML_gmxCodelists.xml#MD_RestrictionCode'
            ]
        }
    },
    dataLegalAccessConstraints: {
        xpaths: {
            root: ['gmd:MD_LegalConstraints[0].gmd:accessConstraints[*]'],
            value: [
                'gmd:MD_RestrictionCode[0]._text[0]',
                'gmd:MD_RestrictionCode[0]._attributes.codeListValue'
            ]
        },
        attributes: {
            codelist: [
                'gmd:MD_RestrictionCode[0]._attributes.codeList',
                'http://standards.iso.org/ittf/PubliclyAvailableStandards/ISO_19139_Schemas/resources/Codelist/ML_gmxCodelists.xml#MD_RestrictionCode'
            ]
        }
    },
    dataLegalAccessInspireConstraints: {
        xpaths: {
            root: ['gmd:MD_LegalConstraints[0].gmd:otherConstraints[*]'],
            value: ['gco:CharacterString[0]._text[0]']
        }
    },
    dataLegalOtherConstraints: {
        xpaths: {
            root: ['gmd:MD_LegalConstraints[0].gmd:otherConstraints[*]'],
            value: ['gco:CharacterString[0]._text[0]']
        }
    },
    dataSecurityUseLimitations: {
        xpaths: {
            root: [
                'gmd:MD_Metadata[0].gmd:identificationInfo[0].gmd:MD_DataIdentification[0].gmd:resourceConstraints[*]',
                'gmd:MD_SecurityConstraints[0].gmd:useLimitation[*]'
            ],
            value: ['gco:CharacterString[0]._text[0]']
        }
    },
    srvSecurityUseLimitations: {
        xpaths: {
            root: [
                'gmd:MD_Metadata[0].gmd:identificationInfo[0].srv:SV_ServiceIdentification[0].gmd:resourceConstraints[*]',
                'gmd:MD_SecurityConstraints[0].gmd:useLimitation[*]'
            ],
            value: ['gco:CharacterString[0]._text[0]']
        }
    },
    dataSecurityClassification: {
        xpaths: {
            root: [
                'gmd:MD_SecurityConstraints[0].gmd:classification[*]'
            ],
            value: [
                'gmd:MD_ClassificationCode[0]._text[0]',
                'gmd:MD_ClassificationCode[0]._attributes.codeListValue'
            ]
        },
        attributes: {
            codelist: [
                'gmd:MD_ClassificationCode[0]._attributes.codeList',
                'http://standards.iso.org/ittf/PubliclyAvailableStandards/ISO_19139_Schemas/resources/Codelist/ML_gmxCodelists.xml#MD_ClassificationCode'
            ]
        }
    },
    _srvSecurityClassification: {
        xpaths: {
            root: [
                'gmd:MD_Metadata[0].gmd:identificationInfo[0].srv:SV_ServiceIdentification[0].gmd:resourceConstraints[*]',
                'gmd:MD_SecurityConstraints[0].gmd:classification[*]'
            ],
            value: [
                'gmd:MD_ClassificationCode[0]._text[0]',
                'gmd:MD_ClassificationCode[0]._attributes.codeListValue'
            ]
        },
        attributes: {
            codelist: [
                'gmd:MD_ClassificationCode[0]._attributes.codeList',
                'http://standards.iso.org/ittf/PubliclyAvailableStandards/ISO_19139_Schemas/resources/Codelist/ML_gmxCodelists.xml#MD_ClassificationCode'
            ]
        }
    },
    dataLinkages: {
        xpaths: {
            value: ['gmd:MD_Metadata[0].gmd:distributionInfo[0].gmd:MD_Distribution[0].gmd:transferOptions[0].gmd:MD_DigitalTransferOptions[0].gmd:onLine[*]']
        }
    },
    linkageName: {
        xpaths: {
            value: ['gmd:CI_OnlineResource[0].gmd:name[0].gco:CharacterString[0]._text[0]']
        }
    },
    linkageDescription: {
        xpaths: {
            value: ['gmd:CI_OnlineResource[0].gmd:description[0].gco:CharacterString[0]._text[0]']
        }
    },
    linkageUrl: {
        xpaths: {
            value: ['gmd:CI_OnlineResource[0].gmd:linkage[0].gmd:URL[0]._text[0]']
        }
    },
    linkageProtocol: {
        xpaths: {
            value: ['gmd:CI_OnlineResource[0].gmd:protocol[0].gco:CharacterString[0]._text[0]']
        }
    },
    dataDqInspireConformities: {
        xpaths: {
            value: ['gmd:MD_Metadata[0].gmd:dataQualityInfo[0].gmd:DQ_DataQuality[0].gmd:report[*]']
        }
    },
    dataDqConformities: {
        xpaths: {
            value: ['gmd:MD_Metadata[0].gmd:dataQualityInfo[0].gmd:DQ_DataQuality[0].gmd:report[*]']
        }
    },
    specification: {
        xpaths: {
            value: ['gmd:DQ_DomainConsistency[0].gmd:result[0].gmd:DQ_ConformanceResult[0].gmd:specification[0].gmd:CI_Citation[0].gmd:title[0].gco:CharacterString[0]._text[0]']
        }
    },
    specificationDateType: {
        xpaths: {
            value: [
                'gmd:DQ_DomainConsistency[0].gmd:result[0].gmd:DQ_ConformanceResult[0].gmd:specification[0].gmd:CI_Citation[0].gmd:date[0].gmd:CI_Date[0].gmd:dateType[0].gmd:CI_DateTypeCode[0]._text[0]',
                'gmd:DQ_DomainConsistency[0].gmd:result[0].gmd:DQ_ConformanceResult[0].gmd:specification[0].gmd:CI_Citation[0].gmd:date[0].gmd:CI_Date[0].gmd:dateType[0].gmd:CI_DateTypeCode[0]._attributes.codeListValue'
            ]
        },
        attributes: {
            codelist: [
                'gmd:DQ_DomainConsistency[0].gmd:result[0].gmd:DQ_ConformanceResult[0].gmd:specification[0].gmd:CI_Citation[0].gmd:date[0].gmd:CI_Date[0].gmd:dateType[0].gmd:CI_DateTypeCode[0]._attributes.codeList',
                'http://standards.iso.org/ittf/PubliclyAvailableStandards/ISO_19139_Schemas/resources/Codelist/ML_gmxCodelists.xml#CI_DateTypeCode'
            ]
        }
    },
    specificationDate: {
        xpaths: {
            value: ['gmd:DQ_DomainConsistency[0].gmd:result[0].gmd:DQ_ConformanceResult[0].gmd:specification[0].gmd:CI_Citation[0].gmd:date[0].gmd:CI_Date[0].gmd:date[0].gco:Date[0]._text[0]']
        }
    },
    explaination: {
        xpaths: {
            value: ['gmd:DQ_DomainConsistency[0].gmd:result[0].gmd:DQ_ConformanceResult[0].gmd:explanation[0].gco:CharacterString[0]._text[0]']
        }
    },
    pass: {
        xpaths: {
            value: ['gmd:DQ_DomainConsistency[0].gmd:result[0].gmd:DQ_ConformanceResult[0].gmd:pass[0].gco:Boolean[0]._text[0]']
        }
    }
}